import { Component, inject, Input, OnInit } from '@angular/core';
import { InputControlData, Item, View } from '@ntap/core';
import { PrimeNGCommonItemViewComponent } from '@ntap/primeng';
import { map, Observable, switchMap, tap } from 'rxjs';
import { FastDataEntryObrasciListProviderDirective } from './service/fast-data-entry-obrasci-list-provider';
import {
  ObrazacUnosaDTO,
  ObrazacUnosaService
} from './service/obrazac-unosa.service';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
@Component({
  selector: 'app-fast-data-entry',
  templateUrl: './fast-data-entry.component.html',
  styleUrls: ['./fast-data-entry.component.scss']
})
export class FastDataEntryComponent
  extends PrimeNGCommonItemViewComponent
  implements OnInit
{
  @Input()
  item: Item;

  private entryTemplateEditableListViewProvider = inject(
    FastDataEntryObrasciListProviderDirective
  );
  private fastDataEntryService = inject(ObrazacUnosaService);

  fastEntryInputs$: Observable<InputControlData[]>;

  override ngOnInit(): void {
    super.ngOnInit();
    this.initEntryTemplateEditableRowInputs();
    this.addSubscription(
      this.fastDataEntryService.selectEntryTemplate$
        .pipe(
          tap((entryTemplate) => {
            this.changeObrazacUpisaPodjedinica(entryTemplate);
          })
        )
        .subscribe()
    );
    this.init(this.item);
  }

  changeObrazacUpisaPodjedinica(entryTemplate: ObrazacUnosaDTO) {
    this.entryTemplateEditableListViewProvider.viewName =
      entryTemplate.name.indexOf('jedinica_gradiva_item') >= 0
        ? 'podrazine'
        : entryTemplate.name.replace('_item', ''); // FIXME maknuti hardkodiranu logiku i neka se list view i item view za svaki entry template dovuku sa servera
    this.entryTemplateEditableListViewProvider.viewState = {
      ...{},
      ...this.entryTemplateEditableListViewProvider.viewState
    };
    this.itemViewProvider.viewName = entryTemplate.name;
    this.itemViewProvider.viewState = {
      $parentId: (this.item as JedinicaGradiva)['en~jedinica_gradiva~id'],
      $itemType: 'en~jedinica_gradiva',
      'en~jedinica_gradiva~id': 0
    };
  }

  private init(item: any) {
    const jedinicaGradivaId = item['en~jedinica_gradiva~id'];
    this.entryTemplateEditableListViewProvider.viewState = {
      'en~jedinica_gradiva~nadredena_jedinica_gradiva': jedinicaGradivaId
    };
    this.fastDataEntryService.selectDefaultEntryTemplate();
  }

  private initEntryTemplateEditableRowInputs() {
    this.fastEntryInputs$ = this.inputs$.pipe(
      switchMap((entryTemplateItemViewInputs: InputControlData[]) =>
        this.transformInputs(entryTemplateItemViewInputs)
      )
    );
  }

  private transformInputs(
    entryTemplateItemViewInputs: InputControlData[]
  ): Observable<InputControlData[]> {
    return this.entryTemplateEditableListViewProvider.view$.pipe(
      map((entryTemplateListView: View) =>
        this.fastDataEntryService.getItemViewAttrsOrderedByListViewAttrs(
          entryTemplateListView,
          entryTemplateItemViewInputs
        )
      )
    );
  }
}
